import React from 'react'
import ButtonC from './ButtonC';
import FadeIn from './FadeIn';
import linkedIn from '../img/LinkedIn.svg'

const teamArr = [
    {
        img: require("../img/teamMember1.png").default,
        title: "Tal Shapsa Heiman",
        designation: <ButtonC btnTxt="CEO" btnBgClr="#DBE0FF" btnClr="#2D2147" btnHeight="34px" className="mx-auto" />,
        detail: "Formerly senior economist in Wall Street (Barclays Bank) and Israel's ministry of finance (Budgets), and founding partner at Out of Line, a startup co-foundry hub with expertise in behavioral product strategy.",
        linkedInIcon: <a href='https://www.linkedin.com/in/tal-shapsa-heiman-9a5ab256' className='linkedIcon' target="_blank" rel="noreferrer"><img src={linkedIn} alt='' /></a>,
        liEvent: "linkedin_tal_button",
    },
    // {
    //     img: require("../img/teamMember2.png").default,
    //     title: "Ofir Shauman",
    //     designation: <ButtonC btnTxt="CPO" btnBgClr="#DBE0FF" btnClr="#2D2147" btnHeight="34px" className="mx-auto" />,
    //     detail: "A serial entrepreneur combining commercial and social activism and solving complex problems with technological tools. Founder of companies in media, proptech and consumer products with a solid technology background (IDF).",
    //     linkedInIcon: <a href='https://www.linkedin.com/in/ofir-shauman' className='linkedIcon' target="_blank" ><img src={linkedIn} alt='' /></a>,
    //     liEvent: "linkedin_ofir_button",
    // },
    {
        img: require("../img/teamMember3.png").default,
        title: "Or Bar-Tal",
        designation: <ButtonC btnTxt="CTO" btnBgClr="#DBE0FF" btnClr="#2D2147" btnHeight="34px" className="mx-auto" />,
        detail: "Experience R&D Lead in successful startups & corporations in the past 10 years. Proficient in the Data / ML/ Architecture /Cybersecurity domains. Ex co-founder & CTO in TechStars backed company.",
        linkedInIcon: <a href='https://www.linkedin.com/in/or-bar-tal-99906582' className='linkedIcon' target="_blank" rel="noreferrer"><img src={linkedIn} alt='' /></a>,
        liEvent: "linkedin_tor_button",
    },
    {
        img: require("../img/teamMember4.png").default,
        title: "Prof. Dan Ariely",
        designation: <ButtonC btnTxt="Chief Behavioral Officer" btnBgClr="#DBE0FF" btnClr="#2D2147" btnHeight="34px" className="mx-auto mainBtnTeamTitle" />,
        detail: "A world leading expert in behavioral economics. founder of the center of advanced hindsight at Duke, co-founder of several successful companies, and three-time NY Times best-selling author.",
        linkedInIcon: <a href='https://www.linkedin.com/in/danariely' className='linkedIcon' target="_blank" rel="noreferrer"><img src={linkedIn} alt='' /></a>,
        liEvent: "linkedin_dan_button",
    },
    {
        img: require("../img/teamMember5.png").default,
        title: "Dr. Ron Sabar",
        designation: <ButtonC btnTxt="Chief Medical Officer" btnBgClr="#DBE0FF" btnClr="#2D2147" btnHeight="34px" className="mx-aut mainBtnTeamTitle" />,
        detail: "A family medicine and palliative care physician for the past 18 years. A thought leader and writer, and th founder and chief medical officer of Sabar Health, Israel's largest home hospital.",
        linkedInIcon: <a href='https://www.linkedin.com/in/ron-sabar' className='linkedIcon' target="_blank" rel="noreferrer"><img src={linkedIn} alt='' /></a>,
        liEvent: "linkedin_ron_button",
    },
    {
        img: require("../img/teamMember6.png").default,
        title: "Dr. Inbal Mayan",
        designation: <ButtonC btnTxt="COO" btnBgClr="#DBE0FF" btnClr="#2D2147" btnHeight="34px" className="mx-auto" />,
        detail: "",
        linkedInIcon: <a href='https://www.linkedin.com/in/inbalmayanmd' className='linkedIcon' target="_blank" rel="noreferrer"><img src={linkedIn} alt='' /></a>,
        liEvent: "linkedin_inbal_button",
    },
    {
        img: require("../img/bruce_team_member.png").default,
        title: "Bruce D. Broussard",
        designation: <ButtonC btnTxt="Acting Chair" btnBgClr="#DBE0FF" btnClr="#2D2147" btnHeight="34px" className="mx-auto mainBtnTeamTitle" />,
        detail: "",
        linkedInIcon: <a href='https://www.linkedin.com/in/bruce-broussard-ba2b69b/' className='linkedIcon' target="_blank" rel="noreferrer"><img src={linkedIn} alt='' /></a>,
        liEvent: "linkedin_bruce_button",
    },
]


const Team = (props) => {
    return (
        <div className='servicesWrap teamSection' id='team'>
            <div className='container'>
                <FadeIn direction='up'>
                    <h1>{props.title}</h1>
                </FadeIn>
                <ul className='teamRow'>
                    {
                        teamArr.map((teamData, index) => (
                            <FadeIn key={index} as='li' direction='up' delay={index * 80}>
                                <div className='teamImg'>{teamData.img ? <img src={teamData.img} alt='' /> : <div className='teamImg__placeholder' />}</div>
                                <h1>{teamData.title}</h1>
                                <span>{teamData.designation}</span>
                                <p>{teamData.detail}</p>
                                {teamData.linkedInIcon}
                            </FadeIn>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}

export default Team
